import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';

function CanterburyTech() {
  return (
    <Container className='hp-page'>
      <Row className='d-flex justify-content-center mx-3'>
        <Col
          xs={8}
          md={3}
          className='d-flex justify-content-center align-items-center pb-3 xs-pb-0'
        >
          <a href='https://canterburytech.nz/' title='Canterbury Tech New Zealand'>
            <Image
              src={
                'https://canterburytech.nz/wp-content/uploads/2024/09/CanterburyTech-Corner-Logo-Lite-Green.svg'
              }
              alt='Canterbury Tech New Zealand Member'
              fluid
              width='100%'
            />
          </a>
        </Col>
        <Col
          xs={8}
          md={7}
          className='d-flex justify-content-center align-items-center'
        >
          <span>
            <h5>HortPlus are a proud member of Canterbury Tech</h5>
            <p>
              HortPlus are proud members of Canterbury Tech, supporting innovation 
              and collaboration in one of New Zealand's leading agricultural and tech hubs.
            </p>
          </span>
        </Col>
      </Row>
    </Container>
  );
}

export default CanterburyTech;
